import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  iconClass: {
    margin: theme.spacing(4),
    padding: theme.spacing(2),
    width: 64,
    height: 64,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: theme.typography.h4.fontSize,
    color: ({ iconColor }) =>
      iconColor ? iconColor : theme.palette.primary.main,
    background: ({ color }) => (color ? color : theme.palette.primary.main),
    borderRadius: '50%',
  },

  iconWrapper: {
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
}))
